import { gql } from '@urql/core';

export const LIVE_EVENTS_SUBSCRIPTION = gql`
  subscription LiveEvents($siteId: Int!) {
    liveEvents(siteId: $siteId) {
      userId
      siteId
      timestamp
      event_type: eventType
      data {
        event_id
        visitor_id
        attributes {
          visitor_id
          visit_id
          url
          path
          sub_event_type
          dead
          rage
          identifier
          device
          country
          referrer
          utm
          fingerprint
          fingerprint_md5
          tags
          form_name
          form_id
          form_action
          time_spent
          goal_name
          addon_name
          unique
          survey_id
          quantity
          product_name
          price
          currency
          total
          order_id
          count
        }
      }
    }
  }
`;
